import { DEFAULT_LOCALE } from 'constants/config';
import { SET_LOCALE } from 'constants/ui';
import { getFieldValue, isTrackingPage } from 'selectors/ui/ui';
import type { PayexThunkAction } from 'store/configureStore';
import { isValidLocale } from 'utils/translations/translations';

export const setLocale =
  (locale: string): PayexThunkAction<Promise<void>> =>
  async (dispatch, getState, { userLanguage }) => {
    const state = getState();
    const isValid = isValidLocale(locale);

    const senderEmail = getFieldValue(state, 'sender_email');
    if (isTrackingPage(state)) {
      userLanguage.update(senderEmail as string, locale);
    }

    dispatch({
      type: SET_LOCALE,
      payload: { locale: isValid ? locale : DEFAULT_LOCALE },
    });
  };
